import React, { useState, useEffect, useContext } from 'react';
import { Card, Form, Row, Col, Button, Space, Descriptions } from 'antd';
import { SaveOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Input from '../../components/input/Input';
import api from '../../services/api';
import { displayMessage } from '../../helpers/messages';
import { showSuccessMessage, showErrorMessage } from '../../services/messages';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import Divider from '../../components/divider/Divider';
import EUserTypes from '../../enums/EUserTypes';
import { BackToHome, useIsOperator } from '../../components/drum/WizardParts';

const DetailProfile = () => {
  const navigate = useNavigate();
  const isOperator = useIsOperator();
  const { loggedUser, setShowLoading } = useContext(GeneralContext);

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (loggedUser) {
      loadUserData();
    }
  }, [loggedUser]);

  const loadUserData = async () => {
    setLoading(true);
    try {
      const response = await api.auth.currentUser();
      setUser(response.data);
      form.setFieldsValue({
        first_name: response.data.first_name,
        last_name: response.data.last_name,
        email: response.data.email,
      });
    } catch (error) {
      showErrorMessage(error?.response?.data?.error || displayMessage('ERROR_LOAD'));
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (values) => {
    setLoading(true);
    try {
      await api.user.update(loggedUser.id, values);
      showSuccessMessage(displayMessage('SUCCESS_UPDATE'));
      loadUserData();
    } catch (error) {
      showErrorMessage(error?.response?.data?.error || displayMessage('ERROR_GENERIC'));
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = () => {
    navigate('/change-password');
  };

  const getUserType = () => {
    if (!user) return 'N/A';
    const userType = Object.values(EUserTypes).find(t => t.code === user.type);
    return userType ? userType.description : 'N/A';
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {isOperator && <BackToHome />}
      <Card title={displayMessage('MY_PROFILE')}>
        <Descriptions bordered column={{ xs: 1, sm: 2 }}>
          <Descriptions.Item label="ID">{user?.id}</Descriptions.Item>
          <Descriptions.Item label={displayMessage('STATUS')} span={2}>
            {user?.is_active ? displayMessage('ACTIVE') : displayMessage('INACTIVE')}
          </Descriptions.Item>
        </Descriptions>

        <Divider>{displayMessage('EDIT_USER')}</Divider>

        <Form
          form={form}
          onFinish={handleSave}
          layout="vertical"
        >
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label={displayMessage('FIRST_NAME')}
                name="first_name"
                rules={[{ required: true, message: displayMessage('ERROR_REQUIRED_FIELD') }]}
              >
                <Input placeholder="Digite o nome" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label={displayMessage('LAST_NAME')}
                name="last_name"
                rules={[{ required: true, message: displayMessage('ERROR_REQUIRED_FIELD') }]}
              >
                <Input placeholder="Digite o sobrenome" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label={displayMessage('EMAIL')}
                name="email"
                rules={[
                  { required: false },
                  { type: 'email', message: displayMessage('ERROR_INVALID_EMAIL') }
                ]}
              >
                <Input placeholder="Digite o e-mail" type="email" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
            <Space>
              <Button
                icon={<LockOutlined />}
                onClick={handleChangePassword}
              >
                {displayMessage('CHANGE_PASSWORD')}
              </Button>
              <Button
                type="primary"
                icon={<SaveOutlined />}
                htmlType="submit"
                loading={loading}
              >
                {displayMessage('SAVE')}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default DetailProfile;



